import { type FC, type ReactNode } from 'react';
import classNames from 'classnames';

import styles from './main.scss';

type WellProps = {
    className?: string;
    children?: ReactNode;
    label?: ReactNode;
    labelClassName?: string;
    hasClearfix?: boolean;
    hasPadding?: boolean;
    hasMargin?: boolean;
    dataTn?: string;
};

export const Well: FC<WellProps> = ({
    className,
    children,
    label,
    labelClassName,
    hasClearfix = true,
    hasPadding = true,
    hasMargin = true,
    dataTn,
}) => {
    return (
        <div
            className={classNames(
                {
                    clearfix: hasClearfix,
                    [styles.padding]: hasPadding,
                    [styles.margin]: hasMargin,
                },
                className,
                styles.well
            )}
            data-tn={dataTn}
        >
            {label && <div className={classNames(labelClassName, styles.label)}>{label}</div>}
            {children}
        </div>
    );
};
